import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/sharp-solid-svg-icons/faMagnifyingGlass';

export const SearchIcon = () => <FontAwesomeIcon icon={faMagnifyingGlass} />;
